import { render, staticRenderFns } from "./ResetPasswordMerchantUserModal.vue?vue&type=template&id=303ba48c&"
import script from "./ResetPasswordMerchantUserModal.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordMerchantUserModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordMerchantUserModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports